import { render, staticRenderFns } from "./storePopup.vue?vue&type=template&id=704ce354&scoped=true&"
import script from "./storePopup.vue?vue&type=script&lang=js&"
export * from "./storePopup.vue?vue&type=script&lang=js&"
import style0 from "./storePopup.vue?vue&type=style&index=0&id=704ce354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ce354",
  null
  
)

export default component.exports